import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { Button, FormGroupRow } from '../../../../common/components';
import { actions } from '../../../source/redux/sourceActions';

import { compose } from 'redux';
import SelectMenu from '../../../../common/components/SelectMenu/SelectMenu';
import ButtonBar from '../../../screening/components/ButtonBar';

const isRequired = (value) => {
  if (value === false) {
    return null;
  }
  return !value ? 'This field is required.' : null;
};

const AssignNewSourceGroupModal = ({
  brokerId,
  onRefreshData,
  updateSource,
  handleSubmit,
  submitting,
  source,
}) => {
  const [show, setShow] = useState(false);

  if (!source) {
    return null;
  }

  const openModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  const updateSourceGroup = (values) => {
    return Promise.resolve(updateSource(source.id, values, ['source_type']))
      .then(() => {
        onRefreshData(brokerId);
      })
      .finally(() => {
        setShow(false);
      });
  };

  return (
    <>
      <Button
        bsStyle="secondary"
        className="pull-right pad-right"
        handleClick={openModal}
      >
        Change Source Group
      </Button>

      <Modal show={show} onHide={closeModal}>
        <Form onSubmit={handleSubmit(updateSourceGroup)}>
          <Modal.Header closeButton>
            <Modal.Title>Assign New Source Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3>Assign New Source Group</h3>

            <FormGroupRow label={'Source Group'} labelSize={4}>
              <Field
                name="data.relationships.source_type.data.id"
                source={'source-types'}
                optionValuePath={'id'}
                component={SelectMenu}
                validate={[isRequired]}
              />
            </FormGroupRow>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBar>
              <Button
                className="pull-right"
                type="submit"
                bsStyle="secondary"
                isLoading={submitting}
                disabled={submitting}
              >
                Update Source Group
              </Button>
              <Button
                className="pull-right"
                bsStyle="default"
                handleClick={closeModal}
                disabled={submitting}
              >
                Cancel
              </Button>
            </ButtonBar>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

const FORM_NAME = 'AssignNewSourceGroupModal';
export default compose(
  connect(
    (state, props) => ({
      initialValues: {
        data: props.source,
      },
      formValues: getFormValues(FORM_NAME)(state),
    }),
    {
      updateSource: actions.updateSource,
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(AssignNewSourceGroupModal);
